import { Component, OnInit, Input } from "@angular/core";
import { ModalController, IonHeader, IonToolbar, IonTitle, 
  IonButton, IonButtons, IonIcon, IonContent, IonFooter } from "@ionic/angular/standalone";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
  selector: "app-info-privacy",
  templateUrl: "./info-privacy.page.html",
  styleUrls: ["./info-privacy.page.scss"],
  imports: [TranslateModule, IonHeader, IonToolbar, IonTitle, IonButton, IonButtons, IonIcon, IonContent, IonFooter],
})
export class InfoPrivacyPage {
  language: string;
  @Input() modalCtrl: ModalController;

  constructor(private translate: TranslateService) {
    addIcons({ close });
  }

  ionViewWillEnter() {
    this.language = this.translate.getCurrentLang();
  }
}
